export default __webpack_public_path__ + "static/media/gp_badge_en.7d441963.webp";